import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { CommissionTierItemDto } from '../../commission-tier-items';

/**
 * Agent category DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.AGENT_CATEGORY)
export class AgentCategorySearchDto extends BaseSearchDto {
  name!: string;
  commissionTierItems?: CommissionTierItemDto[] | null;
  files?: FileDto[] | null;
}
